<app-mini-layout-wrapper>
  <div class="mini-layout__title">{{text.title}}</div>
  <div class="mini-layout__text">{{text.additionalText}}</div>
</app-mini-layout-wrapper>
